import { render } from "./Wish.vue?vue&type=template&id=b0b44c5a&scoped=true"
import script from "./Wish.vue?vue&type=script&lang=js"
export * from "./Wish.vue?vue&type=script&lang=js"

import "./Wish.vue?vue&type=style&index=0&id=b0b44c5a&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\data_dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b44c5a"]])

export default __exports__